module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre4",
    attrs: {
      "id": "pgepubid00034"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page20"
    }
  }), _c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "pgepubid00035",
      "title": "p. 20"
    }
  }), _vm._v("CHAPTER II."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "gutsmall"
  }, [_vm._v("THE FIRE.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Macdonald")]), _vm._v(" and his cousin Jock walked to their lodging in Halkerston’s Wynd without a lanthorn. The watch cried, “Twal o’clock, twal o’clock, and a perishin’ cauld nicht”; they could hear the splash of his shoes in the puddles of the lane although they could not see him. The town now rose above the haar that brooded in the swampy hollow underneath the citadel; the rain was gone, the stars were clear, the wind moaned in the lanes and whistled on the steep. It was like as they were in some wizard fortress cut from rock, walking in mirk ravines, the enormous houses dizzy overhanging them, the "), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00036",
      "title": "p. 21"
    }
  }), _vm._v("closes running to the plains on either hand in sombre gashes. Before them went sedans and swinging lanterns and flambeaux that left in their wake an odour of tow and rosin not in its way unpleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Yon was a dubious prank upon the lady,” said Macdonald, and his cousin laughed uproariously.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Upon my word, Donald,” said he, “I could not for the life of me resist it. I declare it was better than a play; I have paid good money for worse at a play.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“And still and on a roguish thing,” said Macdonald, hastening his step. “You were aye the rogue, Jaunty Jock.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“And you were aye the dullard, Dismal Dan,” retorted the other in no bad humour at the accusation. “To be dull is, maybe, worse. You had the opportunity—I risked that—to betray me if you liked.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“You knew very well I would not do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Well, I thought not, and if you did not "), _c('a', {
    attrs: {
      "id": "page22"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00037",
      "title": "p. 22"
    }
  }), _vm._v("take the chance to clear yourself when you got it, there’s no one but yourself to blame. Here was madam—quite romantical about the Highlands, as I found at our first country dance, and languishing to see this Barrisdale that she has heard from some one—(who the devil knows? that beats me)—was to be at Lady Charlotte’s ball. ‘I’m sorry to say he’s my own cousin,’ says I—‘a Hielan cousin, it does not count when rogues are in the family.’ ‘You must point him out to me,’ said she. I gave her three guesses to pick out the likeliest in the room, and she took you at the first shot.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“A most discerning young person!” said Macdonald.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“She knew your history like a sennachie, lad, and rogue as she made you, I believe she would have forgiven you all but for that nose of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Oh, damn my nose!” cried Macdonald. “It’s not so very different from the common type of noses.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00038",
      "title": "p. 23"
    }
  }), _vm._v("“Just that! just that! not very different, but still a little skew. Lord! man, you cannot expect to have all the graces as well as all the virtues. Madam picked you out at all events, and I was not in the key to contradict her. She paid you (or was it me?) the compliment of saying you were not at all like her idea of a man with the repute of Barrisdale.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Very likely! Indeed, I could guess she was more put out at that than at finding herself speaking to a scamp who laughed at his own misdeeds. You made a false move; Jock, had you admitted you were the man, she would not have been greatly mortified. In any case, she thought to improve the occasion with advice. She told me to be good!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Barrisdale could hardly speak for laughing. “You kept up the play at any rate,” said he, “for when I saw her to her chair, ‘Yon’s an awful man, your cousin,’ said she. What do you think of her?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00039",
      "title": "p. 24"
    }
  }), _vm._v("“Something of a simpleton, something of a sentimentalist, and a very bonny face forbye to judge by her chin—that was all of it I saw.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“She kept too tight a mask for even me to see her face. Man, ye’ve missed her chief charm—she has twa thousand a year of her own. I had it from herself, so you see I’m pretty far ben. With half a chance I could make a runaway match of it; I’m sure I took her fancy.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Tuts! Jock. I thought you had enough of runaway matches; take care she has not got a brother,” said Macdonald.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Jaunty Jock scowled in the dark, but made no answer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("Their lodging was in a land deep down in the Wynd. Flat on flat it rose for fourteen stories, poverty in its dunnies (as they called its cellars), poverty in its attics, and between the two extremes the wonderfullest variety of households bien or wealthy—the homes of writers, clerks, ministers, "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00040",
      "title": "p. 25"
    }
  }), _vm._v("shopkeepers, tradesmen, gentlemen reduced, a countess, and a judge—for there, though the Macdonalds did not know, dwelt Lord Duthie with his daughter. In daytime the traffic of the steep scale stair went like the road to a fair, at night the passages were black and still as vaults. “A fine place the town, no doubt,” said Jaunty Jock, “but, lord, give me the hills for it!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("They slept in different rooms. The morning was still young when one of them was wakened by the most appalling uproar on the stair. He rose and saw his window glowing; he looked from it, and over on the gables of the farther land he saw the dance of light from a fire. He wakened Jaunty Jock. “Get up,” said he, “the tenement’s in blazes.” They dressed in a hurry, and found that every one in the house but themselves had fled already. The door stood open; on the landing crushed the tenants from the flats above, men and women in a state of horror, fighting like brutes for their "), _c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00041",
      "title": "p. 26"
    }
  }), _vm._v("safety. The staircase rang with cries—the sobbing of women, the whimper of bairns, and at the foot a doorway jammed. Frantic to find themselves caught like rats, and the sound of the crackling fire behind them, the trapped ones elbowed and tore for escape, and only the narrowness of the passage kept the weaker ones from being trampled underfoot. All this Macdonald could define only by the evidence of his ears, for the stair was wholly in pitch darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“By God! we’ll burn alive!” said Jaunty Jock, every shred of his manhood gone, and trembling like a leaf. Their door was in a lobby recessed from the landing—an eddy wherein some folk almost naked drifted weeping to find themselves helpless of getting farther. “Where’s the fire?” asked Macdonald from one of them, and had to shake him before he got an answer.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Two landings farther up,” said the fellow, “in Lord Duthie’s flat.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00042",
      "title": "p. 27"
    }
  }), _vm._v("“Lord Duthie’s flat!” cried Macdonald; “and is he safe?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“He’s never hame yet; at least, I never heard him skliffin’ on the stair, but his dochter cam’ back hersel’ frae the assembly.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Is she safe?” asked Macdonald.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Wha’ kens that?” replied the man, and threw himself into the stair, the more able now to fight because of his rest in the eddy.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“It looks gey bad for your runaway match, Jock,” said Macdonald. “Here’s a parcel of the most arrant cowards. My God, what a thin skin of custom lies between the burgess and the brute beast. That poor lass! It’s for you and me, Jock, to go up and see that she’s in no greater danger than the rest of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("He spoke to deaf ears, for Jock was already fighting for his place among the crowd. His cousin did the same, but with another purpose: his object was to scale the stair. He pushed against the pressure of the panic, mountains were on his shoulders, "), _c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00043",
      "title": "p. 28"
    }
  }), _vm._v("and his ribs were squeezed into his body as if with falling rocks. His clothes were torn from his back, he lost his shoes, and a frantic woman struck him on the face with the heavy key of her door that with a housewife’s carefulness she treasured even when the door it was meant for was burned, and the blood streamed into his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("He was still in the dark of the stair; the fire at least was not close enough to stop his mounting, so up he felt his way in a hurry till he reached Lord Duthie’s flat. A lobby that led to the left from the landing roared with flame that scorched him; a lobby on the right was still untouched. He hammered at the only shut door but got no answer, plied the risp as well with the same result, then threw it in with a drive of the shoulders. He gave a cry in the entrance and, getting no response, started to go through the rooms. At the third the lady sat up in her bed and cried at the intruder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00044",
      "title": "p. 29"
    }
  }), _vm._v("“The land’s on fire, ma’am,” said he quietly in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Fire!” she cried in horror. “Oh, what shall I do? Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Barrisdale,” said he, remembering his role and determined to make this his last appearance in it. “You have plenty of time to dress, and I’ll wait for you on the landing.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("He went out with a sudden project in his mind, ran down the stair with its litter of rags and footwear and found it almost vacant, the obstruction at the bottom being cleared. “Take your time, my friends,” said he, “there’s not the slightest danger; the fire will not get this length for half an hour yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("His cousin came back from the crush. “As sure’s death, I’m glad to see you and sorry I never bided,” said he. “You never came on her; I knew very well she must have got out at the outset.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00045",
      "title": "p. 30"
    }
  }), _vm._v("“Indeed!” said Barrisdale. “As it happens, she’s yonder yet, and I had the honour to wake her; I fancy she’s taking her hair from the curl-papers at this moment. You never had a better chance of getting credit for a fine action very cheaply. It was in the dark I wakened her; I told her I was Barrisdale and would return when she was dressed. You may go back to her.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Man, I wouldn’t mind,” said the cousin; “but what’s the object?” he added suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Only that I’m tired of being Barrisdale to suit you. If you like to be Barrisdale and carry your own reputation, you’ll have the name of saving her life—one thing at least to your credit that’ll maybe make her forget the rest. With a creature so romantical, I would not wonder if it came to the runaway match after all.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Faith, I’ll risk it,” said Jaunty Jock, and ran up the stair. He came down with "), _c('a', {
    attrs: {
      "id": "page31"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00046",
      "title": "p. 31"
    }
  }), _vm._v("the lady on his arm, and took her to a neighbour’s.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“And did you confess to your identity?” asked his cousin when they met again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“I did,” he answered gloomily.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Surely she did not boggle at the Barrisdale; I was certain it would make little odds to a lady of her character.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_vm._v("“Oh, she was willing enough, but it’s not a match,” said Jaunty Jock. “After this, I’ll always see the mask off first; she had a worse nose than yourself!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre6"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00047",
      "title": "p. 32"
    }
  }), _c('a', {
    attrs: {
      "id": "page33"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00048",
      "title": "p. 33"
    }
  }), _c('a', {
    attrs: {
      "id": "page34"
    }
  }), _c('a', {
    attrs: {
      "id": "pgepubid00049",
      "title": "p. 34"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0